import script from "./PinArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./PinArea.vue?vue&type=script&setup=true&lang=ts"

import "./PinArea.vue?vue&type=style&index=0&id=258304a5&lang=scss&scoped=true"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258304a5"]])

export default __exports__